import {
  React,
  Component,
  withRouter,
  withCookies,
  axios,
  routes,
} from 'imports/CommonImports';

import {
  InnovationDef,
  Criterias,
} from 'imports/ComponentsImports';

import {
  List,
  Divider,
} from 'material-ui';

import {
  PrimaryButton,
  AlertDialog,
  AlertDialogOneButton,
  LoadingDialog
} from 'imports/DesignImports';

const styles = {
  tutorialTitle: {
    marginLeft: '20px'
  },
  tutorialParagraph: {
    marginLeft: '1.5em'
  }
}

class CommiteeSetupView extends Component {
  constructor(props){
    super(props);
    this.state = {
      token: this.props.cookies.get('token'),
      user: this.props.cookies.get('user'),
      innovation_def: "",
      choices: {},
      textInput: ""
    }
  }

  render() {
    return (
      <div style={styles.pageContainer}>
        <List>
          <div>
            <h1 style={styles.tutorialTitle}>Criterios Base</h1>
            <p style={styles.tutorialParagraph}>En esta sección deberás definir que se entiende como innovación en tu empresa y los criterios que servirán para identificar un proyecto de innovación en tu empresa.</p>
            <Divider />
          </div>
          <InnovationDef send={false} done={this.props.done} update={this.updateInnovationDef}/>
          <Criterias send={false} done={this.props.done} history={this.props.history} update={this.updateCriterias} />
          {!this.props.done ? <div style={{display:'flex', justifyContent:'center'}}>
            <PrimaryButton label="Fijar criterios"
              onClick={() => this.setState({
                alertDialog: true,
                alertTitle: '¡Atención!',
                alertMessage: '¿Estás seguro que quieres enviar los criterios? Estos deben estar aprobados por el comité de gerentes',
                confirm: this.saveCriterias,
                cancel: () => this.setState({alertDialog: false})
            })} />
          </div>:null}
        </List>
        {this.state.loadingDialogOpen ? <LoadingDialog message="Estamos enviando los datos, espera un momento"/> : null}
        { this.state.alertDialogOneButton ?
          <AlertDialogOneButton
          title={this.state.alertTitle}
          message={this.state.alertMessage}
          acceptLabel='Aceptar'
          confirm={this.state.confirm}/> :
          null }
          { this.state.alertDialog ?
            <AlertDialog
            title={this.state.alertTitle}
            message={this.state.alertMessage}
            acceptLabel='Aceptar'
            cancelLabel='Cancelar'
            confirm={this.state.confirm}
            cancel={() => this.setState({alertDialog: false})}/> :
            null }
      </div>
    );
  }

  updateInnovationDef = (def) => {
    this.setState({innovation_def: def});
  }

  updateCriterias = (choices, textInput) => {
    this.setState({choices: choices, textInput: textInput});
  }

  saveCriterias = () => {
    this.saveInnovationDef(this.sendFilters);;
  }

  saveInnovationDef = (callback) => {
    if(this.state.innovation_def !== ""){
      this.setState({loadingDialogOpen: true})
      var innovation_def = {'innovation_def': this.state.innovation_def}
      var connection = axios.create({
        baseURL: routes.host,
        headers: {'Authorization': "Token "+ this.state.token}
      });
      connection.patch(routes.company(this.state.user.company_id), innovation_def)
        .then((response) => {
          callback();
        })
        .catch((error) => {
          this.alertDialogOpen('¡Error!', 'No se pudieron guardar los datos. Intenta nuevamente.');
          console.log(error);
        });
    } else {
      this.alertDialogOpen('¡Error!','Debes completar la definición de innovación antes de fijar los criterios.');
    }
  }

  alertDialogOpen = (title, message, confirm) => {
    this.setState({
      alertDialogOneButton: true,
      alertTitle: title,
      alertMessage: message,
      confirm: confirm,
      loadingDialogOpen: false
    });
  }

  checkFilterCompleteness = () => {
    let completeness = true
    Object.entries(this.state.choices).forEach(
      ([key, option]) => {
        if((option instanceof Array && option.length <= 0) || option === ''){
          completeness = false;
        }
      }
    );
    return completeness;
  }

  sendFilters = () => {
    if(this.checkFilterCompleteness()){
      this.setState({loadingDialogOpen: true})
      var data = []
      Object.entries(this.state.choices).forEach(
        ([key, option]) => {
          if(option instanceof Array){
            option.forEach((opt) => data.push({filterId: key, optionName: opt}))
          }
          else {
            if(key === '31' && this.state.textInput !== ''){
              data.push({filterId: key, optionName: this.state.textInput})
            }
            else{
              data.push({filterId: key, optionName: option})
            }
          }
        }
      );
      var connection = axios.create({
        baseURL: routes.host,
        headers: {'Authorization': "Token "+ this.state.token}
      });
      var postFilters = connection.post(routes.chooseFilters(this.state.user.company_id), data)
      var advanceStage = connection.patch(routes.nextStage(this.state.user.company_id))
      Promise.all([postFilters, advanceStage])
      .then((responses) => {
        this.props.cookies.set('current_stage', JSON.stringify(responses[1].data), { path: '/' });
        this.alertDialogOpen('¡Muy bien!','Has fijado los criterios base para medir el i3 en tu empresa.', () => this.props.history.push('/home'));
      })
      .catch((error) => {
        this.alertDialogOpen('¡Error!', 'No se pudieron guardar los datos. Intenta nuevamente.', () => this.setState({alertDialogOneButton: false}));
        console.log(error);
      });
    }
    else {
      this.alertDialogOpen('¡Error!','Debes llenar todos los campos antes de fijar los criterios', () => this.setState({alertDialogOneButton: false}));
    }

  }

}

export default withCookies(withRouter(CommiteeSetupView));



// WEBPACK FOOTER //
// ./src/views/setup/CommitteeSetupView.js